<button type="button" mat-dialog-close class="close-button">
  <em class="icon-salir"></em>
</button>

<h2 mat-dialog-title class="account-settings-dialog-title">
  Porqué no se podría abrir
</h2>

<div class="mat-dialog-content-wrapper">
  <div mat-dialog-content>
    <ul class="list">
      <li>
        <span>
          Los documentos que se carguen no cumplen con las condiciones
          requeridas.
        </span>
      </li>
      <li>
        <span>
          El proceso de cargue de documentos pudo presentar fallas y no pudimos
          contactarte para resolverlo.
        </span>
      </li>
      <li>
        <span>
          En cualquier caso, la devolución se presentará entre 3 a 5 días
          hábiles
        </span>
      </li>
    </ul>
  </div>
</div>

<div class="actions">
  <button mat-dialog-close class="avv-btn-primary" type="button">
    Continuar
  </button>
</div>
